export default __webpack_public_path__ + "static/media/wellgo_reviewer4.29ebc233.jpg";